import {getUsers, getUsersManagementDependencies} from "~/modules/users/service";
import {namespace} from "vuex-class";
import {User} from "~/lib/models/user";
import {Group} from "~/lib/models/group";
import {Scope} from "~/lib/models/scope";
import {RoleConfig} from "~/modules/users/lib/roles-utils";
import {removeGroup, saveGroup} from "~/modules/groups/service";

type UsersManagementStoreType = {
  state: {
    users: User[],
    totalUsers: number,
    totalUsersFiltered: number,
    groups: Group[],
    rolesConfig: RoleConfig[]
    scopes: Scope[]
  },
  [key:string]: any
};

const defaultState = () => ({
  users:[],
  totalUsers: 0,
  totalUsersFiltered:0,
  groups: [],
  rolesConfig:[],
  scopes:[]
});

export const usersManagement: UsersManagementStoreType = {
  namespaced: true,
  state: defaultState(),
  getters: {
    totalUsers: state => state.totalUsers,
    totalUsersFiltered: state => state.totalUsersFiltered,
    groupsCount: state => state.groups.length,
    roles: state =>  state.rolesConfig.map(config => config.role)
  },
  mutations: {
    setData(state, data){
      state.groups = [...data.groups];
      state.rolesConfig = [...data.rolesConfig];
      state.scopes = [...data.scopes];
    },
    setUsers(state, {users, totalFiltered, total}){
      state.users = users;
      state.totalUsersFiltered = totalFiltered;
      state.totalUsers = total;
    },
    syncGroupsAndUsers(state, { group }){
      // in memory upsert group
      let groupIdx = state.groups.findIndex(gr => gr.id === group.id);
      groupIdx !== -1 ? state.groups.splice( groupIdx, 1, group ) :  state.groups.push(group);
    },
    removeGroup(state, {group}){
      state.groups = state.groups.filter(gr => gr.id !== group.id);
      for(let user of state.users){
        user.removeGroup(group);
      }
    }
  },
  actions: {

    async fetchUsersManagementData(store, clientUUID){
      store.commit("setData", await getUsersManagementDependencies(clientUUID));
    },

    async fetchUsers(store, {clientUUID, ...rest}){
      store.commit("setUsers", await getUsers(clientUUID, rest));
    },

    async saveGroup(store, data){
      const group = await saveGroup(data.group, data.usersUUIDs, data.clientUUID);
      store.commit("syncGroupsAndUsers", { group, usersUUIDs:data.usersUUIDs});
      return group;
    },

    async removeGroup(store, {group}){
      await removeGroup(group.uuid);
      store.commit("removeGroup", { group});
    }

  }

};

export function getUsersManagementStore(): UsersManagementStoreType {
  const bindings:unknown = namespace("usersManagement");
  return bindings as UsersManagementStoreType;
}
